// lib/licensing/storage.ts
//
// Persistencia local del token de licencia y del último heartbeat exitoso.
// En on-prem se guarda en localStorage del navegador/Tauri webview.
// En cloud este módulo no se usa.

const TOKEN_KEY = "heskala.license.token";
const HEARTBEAT_KEY = "heskala.license.lastHeartbeatOkAt";

// Remueve TODO char invisible Unicode: whitespace estándar, zero-width,
// BOM, soft-hyphen, marks bidireccionales, fillers, etc.
// El token pegado puede traer uno o más de estos chars y rompen la
// firma ECDSA porque cambian los bytes del payload.
const INVISIBLE_RE =
  /[\s\u00AD\u061C\u115F\u1160\u180E\u200B-\u200F\u2028-\u202F\u205F-\u206F\uFEFF\uFFF9-\uFFFB]|\u034F|[\u17B4\u17B5]|[\u180B-\u180D]/g;
const cleanToken = (s: string): string => s.replace(INVISIBLE_RE, "");

export function loadLicenseToken(): string | null {
  if (typeof window === "undefined") return null;
  const raw = window.localStorage.getItem(TOKEN_KEY);
  if (!raw) return null;
  const cleaned = cleanToken(raw);
  if (cleaned !== raw) {
    window.localStorage.setItem(TOKEN_KEY, cleaned);
  }
  return cleaned;
}

export function saveLicenseToken(token: string): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(TOKEN_KEY, cleanToken(token));
}

export function clearLicenseToken(): void {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(TOKEN_KEY);
  window.localStorage.removeItem(HEARTBEAT_KEY);
}

export function loadLastHeartbeatAt(): number | null {
  if (typeof window === "undefined") return null;
  const raw = window.localStorage.getItem(HEARTBEAT_KEY);
  if (!raw) return null;
  const n = Number.parseInt(raw, 10);
  return Number.isFinite(n) ? n : null;
}

export function saveLastHeartbeatAt(epochSeconds: number): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(HEARTBEAT_KEY, String(epochSeconds));
}
